import React from "react";
import PolicyLayout from "../../../components/PolicyLayout";
import s from "../../../styles/PolicyLayout.module.css";

export default function PupversePrivacy() {
  return (
    <PolicyLayout
      title="privacy policy"
      appName="Pupverse: Dog Training"
      date="SEPTEMBER 2025"
    >
      <p>
        This Privacy Policy applies to the Pupverse: Dog Training mobile application
        ("Application"), created by Aleksandra Scherbachenko ("Service
        Provider") as a free service. The service is provided on an "AS IS"
        basis.
      </p>

      <div className={s.title}>1) Information Collection and Use</div>
      <p>
        The Application collects information when you download and use it. This
        information may include:
      </p>
      <ul>
        <li>Your device IP address.</li>
        <li>
          The pages of the Application that you visit, date/time of visit, and
          time spent on those pages.
        </li>
        <li>Total time spent in the Application.</li>
        <li>The operating system used on your device.</li>
      </ul>
      <p>
        For a better user experience, the Service Provider may request certain
        personally identifiable information, including but not limited to
        location data and photo data. This information is retained and used as
        described in this policy.
      </p>

      <div className={s.title}>2) Location Data</div>
      <p>
        The Application may collect your device location to estimate
        geographical area and support:
      </p>
      <ul>
        <li>
          Geolocation services, including personalized content and
          location-based features.
        </li>
        <li>
          Analytics and product improvements using aggregated and anonymized
          location data.
        </li>
        <li>
          Third-party service optimization where anonymized location data may be
          transmitted.
        </li>
      </ul>
      <p>
        The Service Provider may also use your information to send important
        notices, required updates, and marketing promotions.
      </p>

      <div className={s.title}>3) Third-Party Access</div>
      <p>
        Only aggregated, anonymized data is periodically transmitted to external
        services to improve the Application and related services.
      </p>
      <p>
        The Application uses third-party services that have their own privacy
        policies, including:
      </p>
      <ul>
        <li>Google Analytics for Firebase.</li>
        <li>Firebase Crashlytics.</li>
        <li>RevenueCat.</li>
      </ul>
      <p>
        The Service Provider may disclose user-provided and automatically
        collected information:
      </p>
      <ul>
        <li>When required by law or legal process.</li>
        <li>
          When disclosure is necessary in good faith to protect rights, safety,
          investigate fraud, or respond to government requests.
        </li>
        <li>
          To trusted service providers that process data on behalf of the
          Service Provider under confidentiality obligations.
        </li>
      </ul>

      <div className={s.title}>4) Opt-Out Rights</div>
      <p>
        You can stop all data collection by uninstalling the Application via
        the standard uninstall process available on your device or app
        marketplace.
      </p>

      <div className={s.title}>5) Data Retention Policy</div>
      <p>
        The Service Provider retains user-provided data while you use the
        Application and for a reasonable period thereafter.
      </p>
      <p>
        If you want user-provided data deleted, contact
        account@goodwavelab.com. Requests are handled within a reasonable time.
      </p>

      <div className={s.title}>6) Children</div>
      <p>
        The Application is not intended for children under 13 years of age, and
        the Service Provider does not knowingly collect personal data from
        children under 13.
      </p>
      <p>
        If personal data of a child under 13 is identified, it will be deleted
        promptly. Parents or guardians can contact account@goodwavelab.com for
        assistance.
      </p>

      <div className={s.title}>7) Security</div>
      <p>
        The Service Provider uses physical, electronic, and procedural
        safeguards to protect the confidentiality and integrity of processed
        information.
      </p>

      <div className={s.title}>8) Changes</div>
      <p>
        This policy may be updated from time to time. Changes are published on
        this page. Continued use of the Application after updates constitutes
        acceptance of revised terms.
      </p>
      <p>This Privacy Policy is effective as of 2025-09-18.</p>

      <div className={s.title}>9) Your Consent</div>
      <p>
        By using the Application, you consent to the processing of your
        information as described in this Privacy Policy, including future
        amendments.
      </p>

      <div className={s.title}>10) Contact Us</div>
      <p>
        If you have questions regarding privacy or data practices, contact the
        Service Provider at account@goodwavelab.com.
      </p>
    </PolicyLayout>
  );
}
